import { HStack, Text, VStack } from '@chakra-ui/react';
import { cloneElement, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeProvider';

export interface IBottomMenuLink {
  name: string;
  icon: JSX.Element;
  path: string;
  desktopName?: string;
  hide?: boolean;
}

function BottomMenuLink({ link }: { link: IBottomMenuLink }) {
  const { colors } = useTheme();
  const isActive = useMemo(() => window.location.pathname === link.path, [link]);

  return (
    <Link style={{ width: '100%', cursor: 'pointer' }} to={link.path}>
      <VStack key={link.name} spacing={1}>
        {cloneElement(link.icon, {
          transition: '0.2s',
          size: '24px',
          color: isActive ? colors.primaryColor : 'black',
        })}
        <Text whiteSpace={'nowrap'} transition={'0.2s'} color={isActive ? 'primaryColor' : 'black'} fontWeight={'500'} fontSize={'12px'}>
          {link.name}
        </Text>
      </VStack>
    </Link>
  );
}

export function BottomMenu({ links }: { links: IBottomMenuLink[] }) {
  const { isIOS } = useTheme();
  return (
    <HStack
      display={{ base: 'flex', lg: 'none' }}
      justify={'space-between'}
      position={'fixed'}
      bottom="0px"
      zIndex={999}
      left={'0px'}
      right={'0px'}
      backgroundColor={'rgba(255,255,255,0.95)'}
      boxShadow="rgba(17, 12, 46, 0.3) 0px 48px 100px 0px"
      backdropFilter={'blur(5px)'}
      padding="10px 0%"
      paddingBottom={'10px'}
    >
      {links.map((l, i) => (
        <BottomMenuLink key={i} link={l} />
      ))}
    </HStack>
  );
}
